import React, { useEffect } from "react";
import "./Waitlisting.css?__remix_sideEffect__";
import leftBackground from "../../../components/atoms/icons/waitlistingLeft.svg";
import rightBackground from "../../../components/atoms/icons/waitlistingRight.svg";
import coschoolLogo from "../../../components/atoms/icons/logoWithBlackText.svg";
import waitlistingBot from "../../../components/atoms/icons/waitlistingBot.svg";
import { clearAllCookies, getCookie } from "../../../utils/TutorConstants";
import { StorageService } from "../../../utils/StorageUtils";
export default function Waitlisting() {
  const handleLinkClick = () => {
    window.location.href = "https://www.coschool.ai/about-us";
  };

  useEffect(() => {
    if (!getCookie("IsDemo")) {
      clearAllCookies();
      StorageService.clear();
    }
  }, []);

  return (
    <div className="modal">
      <div className="container">
        <div className="background">
          <img
            src={leftBackground}
            className="left-bottom-image"
            alt="Left Bottom Image" />

          <img
            src={rightBackground}
            className="right-bottom-image"
            alt="Right Bottom Image" />

        </div>
        <div className="foreground">
          <img src={coschoolLogo} />
          <div className="titleText">Congratulations!</div>
          <div className="subTitle">
            You’re in. Look out for my message on WhatsApp with a link
            <br className="lineBreak" />
            to your personal classroom.
          </div>
          <div className="subTitle">Meanwhile check out my backstory here!</div>
          <div className="linkText" onClick={handleLinkClick}>
            Read more
          </div>

          <img className="bot" src={waitlistingBot} alt="Waitlisting Bot" />
        </div>
      </div>
    </div>);

}